var _style, _title, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:url(#SVGID_1_);} .st1{fill:url(#SVGID_2_);} .st2{fill:url(#SVGID_3_);} ")), /*#__PURE__*/React.createElement("g", null, _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon_Kotlin")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.8525,
    y1: 34.4209,
    x2: -6.4567,
    y2: 35.8167,
    gradientTransform: "matrix(20 0 0 -20 152 716)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    style: {
      stopColor: "#C757BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    style: {
      stopColor: "#CD5CA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    style: {
      stopColor: "#E8744F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    style: {
      stopColor: "#F88316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    style: {
      stopColor: "#FF8900"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.1,0L0,15.8V30l15-15.1L30,0H15.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.1213,
    y1: 34.0294,
    x2: -6.4409,
    y2: 34.7097,
    gradientTransform: "matrix(20 0 0 -20 152 716)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    style: {
      stopColor: "#00AFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    style: {
      stopColor: "#5282FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#945DFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,30l15-15.1L30,30H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.618,
    y1: 35.386,
    x2: -7.1407,
    y2: 35.8633,
    gradientTransform: "matrix(20 0 0 -20 152 716)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    style: {
      stopColor: "#00AFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    style: {
      stopColor: "#5282FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#945DFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,0h15.1L0,15.8V0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/Kotlin.91e07a69935f9654cbc118f045a055a8.svg";
export { ForwardRef as ReactComponent };